import * as types from '../constants/actionTypes';

const dataElementOperands = (state = {}, action) => {
    switch (action.type) {
        case types.DATA_ELEMENT_OPERANDS_SET:
            return {
                ...state,
                [action.groupId]: action.payload,
            };

        default:
            return state;
    }
};

export default dataElementOperands;



// WEBPACK FOOTER //
// ./src/reducers/dataElementOperands.js